module.exports = __webpack_public_path__ + "static/eCommerceHero-6f6dc1edf6384752b3450fb71f76f100.jpg";